import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #QUANTITY PICKER
\*------------------------------------ */
/** 
 * Quantity Picker
 */
.cat-c-quantity-input {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  background: var(--cat-theme-color-form-background);
}

/**
* Styles for quantity picker container
*/
.cat-c-quantity-input__container {
  position: relative;
  width: 100%;
}

/**
* Container for  label, text box and field note
*/
.cat-c-quantity-input__input-container {
  position: relative;
  align-self: stretch;
  align-items: center;
  overflow: hidden;
  border-radius: calc(var(--size-base-unit) * 0.5);
  border: calc(var(--size-base-unit) * 0.125) solid var(--cat-theme-color-form-border);
  display: flex;
  flex-direction: row;
  background: transparent;
  height: calc(var(--size-base-unit) * 6);
}
.cat-c-quantity-input__input-container input::-webkit-outer-spin-button,
.cat-c-quantity-input__input-container input::-webkit-inner-spin-button {
  display: none;
}
.cat-c-quantity-input__input-container:is(:active:hover:not(:disabled), :hover:not(:disabled)) {
  border: calc(var(--size-base-unit) * 0.125) solid var(--cat-theme-color-form-border-hover);
  background: var(--cat-theme-color-form-background-hover);
}
.cat-c-quantity-input__input-container:is(:focus-within, :active:not(:disabled)) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  background: var(--cat-theme-color-form-background);
}
.cat-c-quantity-input--medium .cat-c-quantity-input__input-container {
  height: calc(var(--size-base-unit) * 5);
}
.cat-c-quantity-input--small .cat-c-quantity-input__input-container {
  height: calc(var(--size-base-unit) * 4);
}

/**
* Background style for input box on hover the container
*/
.cat-c-quantity-input__input-container:not(:disabled):is(:hover, :focus-within) .cat-c-quantity-input__input {
  background: transparent;
}

/**
* Layout for the label wrap
*/
.cat-c-quantity-input__label-wrap {
  display: flex;
  align-items: center;
  gap: var(--cat-space-3x-small);
  flex: 1 0 0;
  max-width: 100%;
}

/*
* quantity picker wrapper spacing for medium size 
*/
:is(.cat-c-quantity-input--medium, .cat-c-quantity-input--large) .cat-c-quantity-input__label-wrap {
  margin-block-end: var(--cat-space-x-small);
}

/*
* quantity picker wrapper spacing for small size 
*/
.cat-c-quantity-input--small .cat-c-quantity-input__label-wrap {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  margin-block-end: var(--cat-space-3x-small);
}

/**
* styles for label
*/
.cat-c-quantity-input__label {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  display: flex;
  gap: var(--cat-space-3x-small);
  color: var(--cat-theme-color-content-default);
  flex: 1 0 0;
  max-width: 100%;
  overflow-wrap: break-word;
  /**
   * Hide label
   */
}
.cat-c-quantity-input__label .cat-c-quantity-input__label-text {
  background-color: var(--cat-theme-color-background-default);
}
.cat-c-quantity-input--hidden-label .cat-c-quantity-input__label {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/*
* Hide the label wrapper
*/
.cat-c-quantity-input--hidden-label .cat-c-quantity-input__label-wrap {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

/**
* Required text style
*/
.cat-c-quantity-input__label-notation {
  color: var(--cat-theme-color-content-subtle);
  background-color: var(--cat-theme-color-background-default);
  font-family: var(--cat-theme-typography-footnote-font-family);
  font-weight: var(--cat-theme-typography-footnote-font-weight);
  font-size: var(--cat-theme-typography-footnote-font-size);
  line-height: var(--cat-theme-typography-footnote-line-height);
}
.cat-c-quantity-input--disabled .cat-c-quantity-input__label-notation {
  color: var(--cat-theme-color-content-disabled);
}

/**
* Wrapper style for input
*/
.cat-c-quantity-input__input-wrap {
  display: flex;
  height: 100%;
  position: absolute;
  inset-inline: var(--cat-space-3x-large);
}
.cat-c-quantity-input--small .cat-c-quantity-input__input-wrap {
  inset-inline: var(--cat-space-2x-large);
}
.cat-c-quantity-input--large .cat-c-quantity-input__input-wrap {
  inset-inline: var(--cat-space-4x-large);
}

/**
* Styles for input box
*/
.cat-c-quantity-input__input {
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  display: -webkit-box;
  line-height: var(--cat-line-height-default, var(--cat-line-height-24));
  font-size: var(--cat-font-size-default, var(--cat-font-size-16));
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1 0 0;
  overflow: hidden;
  color: var(--cat-theme-color-content-default);
  text-overflow: ellipsis;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  width: 100%;
}
.cat-c-quantity-input__input:focus {
  outline: none;
  background: var(--cat-theme-color-form-background);
}
.cat-c-quantity-input__input:hover:not(:focus, :focus-within, :disabled) {
  background: var(--component-form-form-background-hover);
}

/*
* Position of value which is hidden
*/
.cat-c-quantity__input-value {
  position: absolute;
  inset-inline-start: 50%;
  inset-block-start: 15%;
}

/*
* Color style update for filling/focussing state
*/
.cat-c-quantity-input__input-container:focus-within .cat-c-quantity-input__input {
  color: var(--cat-theme-color-content-default);
}

/**
* Styles for quantity picker wrapper
*/
.cat-c-quantity-input__button-wrap {
  display: flex;
  align-items: center;
}

/*
* Styles update for quantity picker wrap for small size
*/
.cat-c-quantity-input--small .cat-c-quantity-input__button-wrap {
  inset-block-end: calc(var(--size-base-unit) * 0.125);
}

/**
* Cat icon and individual cat icon wrappers
*/
cat-icon,
.cat-icon {
  /**
  * Cat icon and individual cat icon wrappers within quantity picker button
  * 1) Because it's a slot in a slot, icons don't inherit the bare button icon size
  */
}
.cat-c-quantity-input__button cat-icon,
.cat-c-quantity-input__button .cat-icon {
  color: var(--cat-theme-color-content-default);
  font-weight: var(--cat-font-weight-regular);
}

/**
 * Left button
 */
.cat-c-quantity-input__button-left {
  position: absolute;
  inset-inline-start: 0;
}
.cat-c-quantity-input__input-loader .cat-c-quantity-input__button-left {
  position: relative;
}

/**
 * Right button
 */
.cat-c-quantity-input__button-right {
  position: absolute;
  inset-inline-end: 0;
}
.cat-c-quantity-input__input-loader .cat-c-quantity-input__button-right {
  text-align: center;
}

/**
 * Left and Right button icon
 */
.cat-c-quantity__add-icon,
.cat-c-quantity__minus-icon {
  pointer-events: none;
}

/**
 * Disabled style
 */
.cat-c-quantity-input--disabled {
  cursor: not-allowed;
  --cat-icon-fill: var(--cat-theme-color-button-content-disabled);
  color: var(--cat-theme-color-content-disabled);
  /**
  * Removed pointer events for quantity picker Buttons
  */
  /*
  * Styles for input container
  */
}
.cat-c-quantity-input--disabled .cat-c-quantity-input__input {
  background: var(--cat-theme-color-background-default-disabled);
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-quantity-input--disabled cat-button {
  pointer-events: none;
}
.cat-c-quantity-input--disabled:hover {
  cursor: not-allowed;
}
.cat-c-quantity-input--disabled .cat-c-quantity-input__input-container {
  border: calc(var(--size-base-unit) * 0.125) solid var(--cat-theme-color-border-disabled);
  background: var(--cat-theme-color-background-default-disabled);
  pointer-events: none;
}
.cat-c-quantity-input--disabled .cat-c-quantity-input__label {
  color: var(--cat-theme-color-content-disabled);
  pointer-events: none;
}
.cat-c-quantity-input--disabled cat-field-note {
  color: var(--cat-theme-color-content-disabled);
}

/*
  * Styles for error
  */
.cat-is-error .cat-c-quantity-input__input-container {
  border: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-border-utility-error);
  background: var(--cat-theme-color-form-background);
}
.cat-is-error .cat-c-quantity-input__input-container:hover:not(:focus, :focus-within, :disabled, :active) {
  outline: calc(var(--size-base-unit) * 0.25) solid var(--cat-theme-color-content-utility-error);
  outline-offset: calc(var(--size-base-unit) * -0.25);
  background: var(--cat-theme-color-form-background-hover);
}
.cat-is-error .cat-c-quantity-input__input-container:is(:focus-within, :active):not(:disabled) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  background: var(--cat-theme-color-form-background);
}
.cat-is-error .cat-c-quantity-input__input-container:hover:not(:disabled) {
  background: var(--cat-theme-color-form-background-hover);
}

.cat-is-error.cat-c-quantity-input--disabled .cat-c-quantity-input__input-container {
  background: var(--cat-theme-color-background-default-disabled);
}

/*
  * Styles for readonly
  */
.cat-is-readonly {
  pointer-events: none;
  --cat-icon-fill: var(--cat-theme-color-button-content-disabled);
}
.cat-is-readonly .cat-c-quantity-input__input-container {
  border: 1px solid var(--cat-theme-color-border-disabled);
  background: var(--cat-theme-color-form-background);
}
.cat-is-readonly .cat-c-quantity-input__input {
  background: var(--cat-theme-color-form-background);
  color: var(--cat-theme-color-content-subtle);
}

/*
  * Styles for input loading state
  */
.cat-c-quantity-input__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 3);
  position: relative;
}
.cat-c-quantity-input__input-loader .cat-c-quantity-input--small {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2);
}
.cat-c-quantity-input__input-loader .cat-c-quantity-input--large {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 3);
}
.cat-c-quantity-input__input-loader .cat-c-quantity-input__button-wrap {
  display: flex;
  position: absolute;
  inset-block: 0;
  width: 100%;
  text-align: center;
  align-items: center;
}

/*
* Styles for loading state
*/
.cat-c-quantity-input--loader {
  --cat-icon-fill: var(--cat-theme-color-button-content-disabled);
}
.cat-c-quantity-input--loader .cat-c-quantity-input__button-wrap {
  pointer-events: none;
}
.cat-c-quantity-input--loader .cat-c-quantity-input__footer {
  width: 100%;
  margin-block-start: var(--cat-space-3x-small);
}
.cat-c-quantity-input--loader .cat-c-quantity-input__label {
  width: 100%;
  display: block;
  margin-block-end: var(--cat-space-x-small);
}

/*
* Style update for loading for medium size
*/
.cat-c-quantity-input--medium .cat-c-quantity-input__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2.5);
}

/*
* Style update for loading for small size
*/
.cat-c-quantity-input--small .cat-c-quantity-input__input-loader {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 2);
}

.cat-c-quantity-input:not(.cat-c-quantity-input--has-field-note) .cat-c-quantity-input__field-note-wrapper, .cat-c-quantity-input:not(.cat-c-quantity-input--has-error-note) .cat-c-quantity-input__error-note-wrapper, .cat-c-quantity-input:not(.cat-c-quantity-input--has-warning-note) .cat-c-quantity-input__warning-note-wrapper {
  display: none;
}
`;
       